import React from "react";
import styled, { css } from "styled-components";

/*
  severity : primary, secondary, light, primary_light
  small: true, false
  size: small, middle, large
  disable : on, off
*/
const Button = props => {
  return (
    <Container
      severity={props.severity}
      disable={props.disable}
      size={props.size}
      small={props.small}
      onClick={props.clickEvent}
      style={props.buttonStyle}>
      {props.L_ICON && <img src={props.L_ICON} />}
      <Text severity={props.severity} disable={props.disable}>
        {props.children}
      </Text>
      {props.R_ICON && <img src={props.R_ICON} />}
    </Container>
  );
};

const BgColor = (severity, disable) => {
  switch (severity) {
    case "primary":
      if (!disable || disable === "off") {
        return "#6B65DE";
      } else {
        return "#C4C1F2";
      }
    case "primary_light":
      if (!disable || disable === "off") {
        return "#F5F2FA";
      } else {
        return "#FBFAFD";
      }
    case "secondary": {
      if (!disable || disable === "off") {
        return "#48454D";
      } else {
        return "#CBCBCC";
      }
    }
    case "light":
      if (!disable || disable === "off") {
        return "#F3F3F7";
      } else {
        return "#F3F3F7";
      }
  }
};

const FontColor = (severity, disable) => {
  switch (severity) {
    case "primary":
      if (!disable || disable === "off") {
        return "#FFF";
      } else {
        return "#FFF";
      }
    case "primary_light":
      if (!disable || disable === "off") {
        return "#6B65DE";
      } else {
        return "#C4C1F2";
      }
    case "secondary": {
      if (!disable || disable === "off") {
        return "#FFF";
      } else {
        return "#FFF";
      }
    }
    case "light":
      if (!disable || disable === "off") {
        return "#666";
      } else {
        return "#BBBBBD";
      }
  }
};

const Container = styled.div`
  display: flex;
  /* width: 100%; */
  ${props =>
    !props.small &&
    css`
      width: 100%;
    `}

  ${props =>
    props.size === "large" &&
    css`
      width: 100% !important;
    `}
  ${props =>
    props.size === "middle" &&
    css`
      width: 50% !important;
    `}


  padding: ${props => (props.small ? "12px 12px" : "16px 0px")};
  justify-content: center;
  align-items: center;
  gap: 8px;

  border-radius: 6px;
  background: ${props => BgColor(props.severity, props.disable)};
`;

const Text = styled.div`
  color: ${(props) => FontColor(props.severity, props.disable)};

  /* Body/2/SemiBold */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.28px;
`;

export default Button;
